module.exports = __webpack_public_path__ + "assets/media/day13.bf126e4e.mp3";